<template>
  <div class="pages">
    <!-- <div class="container detail" v-html="language=== 'en' ? datas.enContent : language=== 'ru' ? datas.enContent : datas.content"></div> -->
    <div class="container aboutUs">
      <div class="images">
        <div class="contents">
         <p>{{$t("aboutsUscontents")}}</p> 
         <p>{{$t("aboutsUscontents1")}}</p> 
         <p>{{$t("aboutsUscontents2")}}</p> 
        </div>
        <img src="../../assets/tianshi/aboutbj.jpg" alt />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getCompanyInfo } from '@/api/home'

export default {
  name: 'pageDetail',
  data() {
    return {
      datas: {}
    }
  },
  computed: {
    ...mapState('operate', ['language'])
  },
  created() {
    // this.init()
  },
  methods: {
    init() {
      // 获取公司简介
      getCompanyInfo().then(res => {
        if (res.success) {
          this.datas = res.data
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.pages {
  background: linear-gradient(135deg, #aee7fb, #fadbea 51%, #f9e1cf);
  padding-top: 30px;
  padding-bottom: 50px;
  .aboutUs {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    background: #ffffff;
    border-radius: 12px;
    padding: 50px 0;
  }
  .images {
    margin: 0 auto;
  }
  .contents {
    font-size: 18px;
    font-weight: 400;
    color: #666666;
    margin-bottom: 27px;
    width: 1200px;
    p{
      text-indent: 2em;
    }
  }
}
// .detail {
//   padding: 40px 0;

//   & img {
//     max-width: 100%;
//   }
// }
</style>
